module.exports = __webpack_public_path__ + "img/trophy.26898034.svg";